import React from 'react';

import Popup from '../../Popup';

import styles from './welcomePopUps.scss';
import PbrRating from '../../text/PbrRating';

import utrRangeStyles from '../../Profile/RatingDisplayV2/ratingDisplayV2.scss';

const PbrRangePopup = (props) => {
    const {
        onCloseClick,
        rating,
    } = props;

    return (
        <Popup
            className={`popup-md`}
            popUpClassName={`${styles.welcomePopUp}`}
            onCloseClick={onCloseClick}
            config={{
                noPadding: true,
                fullScreen: false,
                topGradient: false,
                scrollable: false,
            }}
            data-testid="modal.pbr-range"
        >
            <div className={`${styles.section} ${utrRangeStyles.ratingDisplay} text-center pt16 pb8`}>
                <div className={utrRangeStyles.utrRange}>
                    <PbrRating pbrRating={rating.pbrRating} showLabel={true} />
                    <div className={utrRangeStyles.description} data-testid="modal.pbr-range.rating-label">Estimated Color Ball Rating</div>
                </div>
            </div>
            <div className={`${styles.section} text-center pt16`}>
                <div className={`mb24`}>
                    <p className="text-dark" data-testid="modal.pbr-range.description">
                        This is your approximate Color Ball Rating based on the playing experience you have. As you play and scores are posted your Color Ball Rating will become more accurate.
                    </p>
                </div>
                <div className="mt48">
                    <button
                        type="button"
                        className="btn btn-primary btn-xl btn-block text-uppercase"
                        onClick={onCloseClick}
                        data-testid="modal.pbr-range.ok-btn"
                    >
                        OK
                    </button>
                </div>
            </div>
        </Popup>
    );
};

export default PbrRangePopup;
